import {
  FETCH_BANK_ACCOUNTS_REQUEST,
  FETCH_BANK_ACCOUNTS_SUCCESS,
  FETCH_BANK_ACCOUNTS_FAILURE,
  CREATE_BANK_ACCOUNT_REQUEST,
  CREATE_BANK_ACCOUNT_SUCCESS,
  CREATE_BANK_ACCOUNT_FAILURE,
  UPDATE_BANK_ACCOUNT_REQUEST,
  UPDATE_BANK_ACCOUNT_SUCCESS,
  UPDATE_BANK_ACCOUNT_FAILURE,
  DELETE_BANK_ACCOUNT_REQUEST,
  DELETE_BANK_ACCOUNT_SUCCESS,
  DELETE_BANK_ACCOUNT_FAILURE
} from '../../Action/BankAction/BankAction';

const initialState = {
  bankAccounts: [],
  total: 0,
  loading: false,
  actionLoading: false,
  error: null
};

const BankReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BANK_ACCOUNTS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_BANK_ACCOUNTS_SUCCESS:
      return {
        ...state,
        loading: false,
        bankAccounts: action.payload.accounts || [],
        total: action.payload.total || 0
      };
    case FETCH_BANK_ACCOUNTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_BANK_ACCOUNT_REQUEST:
    case UPDATE_BANK_ACCOUNT_REQUEST:
    case DELETE_BANK_ACCOUNT_REQUEST:
      return { ...state, actionLoading: true, error: null };

    case CREATE_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        bankAccounts: [action.payload, ...state.bankAccounts]
      };

    case UPDATE_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        bankAccounts: state.bankAccounts.map(acc =>
          acc.id === action.payload.id ? action.payload : acc
        )
      };

    case DELETE_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        bankAccounts: state.bankAccounts.filter(acc => acc.id !== action.payload)
      };

    case CREATE_BANK_ACCOUNT_FAILURE:
    case UPDATE_BANK_ACCOUNT_FAILURE:
    case DELETE_BANK_ACCOUNT_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default BankReducer;